import { render, staticRenderFns } from "./BusinessNameDataUpdateTaskQueueLevel4.vue?vue&type=template&id=03db1a60&scoped=true&"
import script from "./BusinessNameDataUpdateTaskQueueLevel4.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateTaskQueueLevel4.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateTaskQueueLevel4.vue?vue&type=style&index=0&id=03db1a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03db1a60",
  null
  
)

export default component.exports